import { useState } from "react";

export default function SecretPathPage() {
  const [loading, setLoading] = useState(true);

  return (
    <main className="secret-path-page page">
      <div className="w-full h-[calc(100vh-100px)] relative">
        <h1 className="flex text-5xl font-semibold text-gray-800 portrait:text-3xl lg:text-5xl md:text-5xl sm:text-3xl ps-6 py-6">
              Secret Path</h1>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <span className="loader"></span>
          </div>
        )}

        <iframe
          title="Secret Path"
          className="airtable-embed"
          src="https://airtable.com/embed/apprWesJGBmsmfsWx/shrF3HpLvXKMj1oMl"
          frameBorder="0"
          width="100%"
          height="100%"
          style={{ background: "transparent", border: "1px solid var(--color-border-subtle)" }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
